var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"warning-box",class:{ danger: _vm.danger }},[_c('i',{staticClass:"fa-regular fa-triangle-exclamation"}),(_vm.location)?_c('span',{staticClass:"font-weight-bold pr-1"},[_vm._v(_vm._s(_vm.location))]):_vm._e(),(_vm.type === 'Other')?_c('span',[_vm._v(_vm._s(_vm.reference))]):_c('span',[_vm._v(" "+_vm._s(_vm.message)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }